hp6-semantic {
  // hide slot content until hydrated
  &:not(.hydrated) {
    visibility: hidden;
  }

  display: block;
}

hp6-heading[size-selection="xl"] {
  + hp6-semantic[size-selection="xl"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="lg"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="md"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="sm"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xs"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xxs"] {
    margin-top: var(--spacing-xxs);
  }
}

hp6-heading[size-selection="lg"] {
  + hp6-semantic[size-selection="xl"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="lg"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="md"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="sm"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xs"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xxs"] {
    margin-top: var(--spacing-xxs);
  }
}

hp6-heading[size-selection="md"] {
  + hp6-semantic[size-selection="xl"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="lg"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="md"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="sm"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xs"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xxs"] {
    margin-top: var(--spacing-xxs);
  }
}

hp6-heading[size-selection="sm"] {
  + hp6-semantic[size-selection="xl"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="lg"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="md"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="sm"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xs"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xxs"] {
    margin-top: var(--spacing-xxs);
  }
}

hp6-heading[size-selection="xs"] {
  + hp6-semantic[size-selection="xl"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="lg"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="md"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="sm"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xs"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xxs"] {
    margin-top: var(--spacing-xxs);
  }
}

hp6-heading[size-selection="xxs"] {
  + hp6-semantic[size-selection="xl"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="lg"] {
    margin-top: var(--spacing-md);
  }

  + hp6-semantic[size-selection="md"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="sm"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xs"] {
    margin-top: var(--spacing-sm);
  }

  + hp6-semantic[size-selection="xxs"] {
    margin-top: var(--spacing-xxs);
  }
}
